(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patch-report-item', {
            parent: 'entity',
            url: '/patch-report-item?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-item/patch-report-items.html',
                    controller: 'PatchReportItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('patch-report-item-detail', {
            parent: 'entity',
            url: '/patch-report-item/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.patchReportItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patch-report-item/patch-report-item-detail.html',
                    controller: 'PatchReportItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('patchReportItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PatchReportItem', function($stateParams, PatchReportItem) {
                    return PatchReportItem.get({id : $stateParams.id});
                }]
            }
        })
        .state('patch-report-item.new', {
            parent: 'patch-report-item',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-item/patch-report-item-dialog.html',
                    controller: 'PatchReportItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                monthlyQuantity: null,
                                durationInMonths: null,
                                bodyArea: null,
                                participationPercent: null,
                                comment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patch-report-item', null, { reload: true });
                }, function() {
                    $state.go('patch-report-item');
                });
            }]
        })
        .state('patch-report-item.edit', {
            parent: 'patch-report-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-item/patch-report-item-dialog.html',
                    controller: 'PatchReportItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatchReportItem', function(PatchReportItem) {
                            return PatchReportItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patch-report-item.delete', {
            parent: 'patch-report-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patch-report-item/patch-report-item-delete-dialog.html',
                    controller: 'PatchReportItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatchReportItem', function(PatchReportItem) {
                            return PatchReportItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('patch-report-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
